export default "__VITE_ASSET__b82e373f__"